import {SerpEngines as serpEngine} from "../../constants/serpEngines";
import {ArrayHelper} from "../../helpers/ArrayHelper";
import {BaseEngineIcons} from "../../constants/baseEngineIcons";
import {ClusteringSystemArts} from "../clustering/constants/systemArts";
import {Periodicity} from "./constants/Periodicity";
import {Operators} from "./constants/Operators";
import moment from "moment/moment";
import {HashHelper} from "keysso/helpers/HashHelper";

const SEARCH_ENGINES = [
    {id: 'yandex', icon: BaseEngineIcons.yandex, caption: 'Яндекс'},
    {id: 'google', icon: BaseEngineIcons.google, caption: 'Google'},
];

/**
 * Запрещенные для вывода в списке папки
 */
const DISABLED_SELECT_ARTS = [
    ClusteringSystemArts.ROOT,
    ClusteringSystemArts.DELETED
];

export class DataTransformer
{
    /**
     * Формируем данные по поиску регионов из полученных данных в формат для компонента
     * @param data{{
     *     regionId: Number,
     *     regionName: String,
     *     engine: Number,
     * }[]}
     *
     * @returns {{
     *     engine: {
     *         id: Number,
     *         icon: String,
     *         caption: String,
     *     },
     *     region: {
     *         id: Number,
     *         short_title: String,
     *     },
     *     device: String,
     * }[]}
     */
    static searchFromRequest(data) {
        let formattedData = [];
        data.map(item => {
            const formattedItem = this.searchSingleFromRequest(item)

            formattedData.push(formattedItem);
        });

        return formattedData;
    }

    /**
     * Формируем данные по поиску регионов из полученных данных списка проектов в формат для компонента
     * @param data{{
     *     region_id: Number,
     *     region_name: String,
     *     search_engine: Number,
     * }}
     *
     * @returns {{
     *     engine: {
     *         id: Number,
     *         icon: String,
     *         caption: String,
     *     },
     *     region: {
     *         id: Number,
     *         short_title: String,
     *     },
     *     device: String,
     * }[]}
     */
    static searchFromRequestList(data) {
        let formattedData = [];
        data.map(item => {
            const itemFormatted = {
                regionId: item.region_id,
                regionName: item.region_name,
                engine: item.search_engine,
            };
            const formattedItem = this.searchSingleFromRequest(itemFormatted)

            formattedData.push(formattedItem);
        });

        return formattedData;
    }

    /**
     * Формируем данные по поиску регионов из полученных данных в формат для компонента
     * @param item{{
     *     regionId: Number,
     *     regionName: String,
     *     engine: Number,
     * }}
     *
     * @returns {{
     *     engine: {
     *         id: Number,
     *         icon: String,
     *         caption: String,
     *     },
     *     region: {
     *         id: Number,
     *         short_title: String,
     *     },
     *     device: String,
     * }}
     */
    static searchSingleFromRequest(item) {
        let formattedItem = {
            engine: {
                id: null,
            },
            region: {
                id: item.regionId,
                short_title: item.regionName,
            },
            device: null
        };

        switch (item.engine) {
            case serpEngine.YandexDesktop: {
                formattedItem = Object.assign({}, formattedItem, {engine: {id: 'yandex'}, device: 'desktop'});
                break;
            }
            case serpEngine.YandexMobile: {
                formattedItem = Object.assign({}, formattedItem, {engine: {id: 'yandex'}, device: 'mobile'});
                break;
            }
            case serpEngine.GoogleDesktop: {
                formattedItem = Object.assign({}, formattedItem, {engine: {id: 'google'}, device: 'desktop'});
                break;
            }
            case serpEngine.GoogleMobile: {
                formattedItem = Object.assign({}, formattedItem, {engine: {id: 'google'}, device: 'mobile'});
                break;
            }
        }

        formattedItem.engine = ArrayHelper.getObjectByAttrValue(SEARCH_ENGINES, 'id', formattedItem.engine.id);

        return formattedItem;
    }
    /**
     * Формируем данные по поиску регионов из формата для компонента в формат для отправки API
     * @param data{{
     *     region: {
     *         id: Number,
     *         short_title: String,
     *     },
     *     engine: {
     *         id: String,
     *         icon: String,
     *         caption: String
     *     },
     *     device: String,
     * }[]}
     *
     * @returns {{
     *     regionId: Number,
     *     language: Number,
     *     engine: Number,
     * }[]}
     */
    static searchForRequest(data) {
        let formattedData = [];
        data.map(item => {
            const formattedItem = this.searchSingleForRequestFormat(item);

            formattedData.push(formattedItem);
        });

        return formattedData;
    }

    /**
     * Формируем данные региона из формата для компонента в формат для отправки API
     * @param item{{
     *     region: {
     *         id: Number,
     *         short_title: String,
     *     },
     *     engine: {
     *         id: String,
     *         icon: String,
     *         caption: String
     *     },
     *     device: String,
     * }}
     *
     * @returns {{
     *     regionId: Number,
     *     language: Number,
     *     engine: Number
     * }}
     */
    static searchSingleForRequestFormat(item) {
        let formattedItem = {
            regionId: item.region.id ?? null,
            engine: null,
        }
        if (item.engine.id === 'yandex' && item.device === 'desktop') {
            formattedItem.engine = serpEngine.YandexDesktop;
        } else if (item.engine.id === 'yandex' && item.device === 'mobile') {
            formattedItem.engine = serpEngine.YandexMobile;
        } else if (item.engine.id === 'google' && item.device === 'desktop') {
            formattedItem.engine = serpEngine.GoogleDesktop;
        } else if (item.engine.id === 'google' && item.device === 'mobile') {
            formattedItem.engine = serpEngine.GoogleMobile;
        }

        return formattedItem;
    }

    /**
     * Формируем данные для компонента из полученного формата Backend
     * @param data{{
     *     name: String,
     *     id: Number,
     *     pid: Number,
     *     keys_count: Number,
     *     ws_sum: Number,
     *     wsk_sum: Number,
     *     superwsk_sum: Number,
     *     max_key_ws: Number,
     *     max_key_wsk: Number,
     *     max_key_superwsk: Number,
     *     lock: Boolean,
     *     children: Array
     * }[]}
     * @returns {{
     *     name: String,
     *     id: Number,
     * }[]}
     */
    static artsFromRequest(data) {
        let formattedData = [];

        data.forEach(item => {
            // Пропускаем элементы с id 0 и -1
            if (!DISABLED_SELECT_ARTS.includes(item.id)) {
                formattedData.push({id: item.id, name: item.name});
            }

            // Если есть children, рекурсивно обрабатываем их
            if (item.children && item.children.length > 0) {
                formattedData = formattedData.concat(this.artsFromRequest(item.children));
            }
        });

        return formattedData;
    }

    /**
     * Формируем данные из формата Хэша в формат данных моделей
     * @param searchSettings{{
     *     regionId: Number,
     *     regionName: String,
     *     engine: Number,
     * }[]}
     *
     * Первый объект - перезагружаемые данные при изменении для запроса,
     * второй объект - статические опции страницы, влияют только на отображение и поведение
     * @returns {[
     *      {
     *          regions: {
     *              region: {
     *                  id: number,
     *              },
     *              engine: {
     *                  id: string,
     *              },
     *              device: string,
     *          }[],
     *          compare: boolean,
     *          selectedArts: number[],
     *          dateFrom: string,
     *          dateTo: string,
     *          search: string,
     *          domains: string[],
     *      },
     *      {
     *          hideChart: boolean,
     *          viewType: string,
     *          positionType: string,
     *      },
     *  ]}
     */
    static dataFromHash(searchSettings) {
        const hashVariables = HashHelper.getVariables();

        let data = {};
        let options = {};
        for (const [key, value] of Object.entries(hashVariables)) {
            switch (key) {
                case 'hideChart':
                    Object.assign(options, {[key]: value === 'true'});
                    break;
                case 'viewType':
                case 'positionType':
                    Object.assign(options, {[key]: value});
                    break;
                case 'compare':
                    Object.assign(options, {[key]: value === 'true'});
                    break;
                case 'regions':
                    const parsedValue = JSON.parse(value);
                    if (!parsedValue.length) {
                        break;
                    }

                    let regions = [];
                    parsedValue.map(itemRegion => {
                        const [regionId, engine] = itemRegion;
                        const region = searchSettings.find(
                            item => (item.regionId === regionId && item.engine === engine)
                        );

                        if (region) {
                            return regions.push(region)
                        }
                    });

                    if (regions) {
                        Object.assign(data, {[key]: this.searchFromRequest(regions)});
                    }
                    break;
                case 'arts':
                    Object.assign(data, {['selectedArts']: JSON.parse(value)});
                    break;
                case 'dateFrom':
                case 'dateTo':
                case 'search':
                case 'filter':
                    Object.assign(data, {[key]: value});
                    break;
                case 'domains':
                    const domains = JSON.parse(value);
                    if (domains.length) {
                        Object.assign(data, {['domains']: domains});
                    }
                    break;
            }
        }

        return [data, options];
    }

    /**
     * Формируем данные из моделей компонента в формат Хэша
     * @param modelData{{
     *     regions: {
     *         region: {
     *             id: number,
     *             short_title: string,
     *         },
     *         engine: {
     *             id: string,
     *             icon: string,
     *             caption: string
     *         },
     *         device: string,
     *     }[],
     *     compare: boolean,
     *     dateFrom: string,
     *     dateTo: string,
     *     search: string,
     *     selectedArts: number[],
     *     filter: {
     *         // or|and
     *         type: string,
     *         field: string,
     *         operator: string,
     *         // может иметь любое значение, в зависимости от оператора
     *         value: null|number|array|string,
     *     }[],
     *     domains: string[],
     * }},
     * @param modelOptions{{
     *     hideChart: boolean,
     *     positionType: string,
     *     viewType: string,
     * }}
     * @returns {string} строка хэша
     */
    static hashFromModels(modelData, modelOptions) {
        let models = Object.assign({}, modelData, modelOptions);
        let regions = [];
        Object.values(models.regions).map(item => {
            const itemRequest = this.searchSingleForRequestFormat(item);
            if (!itemRequest) {
                return;
            }

            regions.push([itemRequest.regionId, itemRequest.engine]);
        });

        models.regions = JSON.stringify(regions);
        models.arts = JSON.stringify(models.selectedArts);
        models.domains = JSON.stringify(ArrayHelper.getAttrValuesOfObjectsByName(models.domains, 'trackingItem'));
        delete models.selectedArts;

        return HashHelper.getHash(models);
    }

    /**
     * Формируем данные из формата API для формата модели компонента
     * @param dataResponse
     * @returns {{
     *      domain: String,
     *      subdomains: Boolean,
     *      name: String,
     *      searchSettings: {
     *          engine: {
     *              id: Number
     *          },
     *          region: {
     *              id: Number,
     *              short_title: String
     *          },
     *          device: String
     *      }[],
     *      notifications: {
     *          isNotifyMuted: Boolean,
     *          email: Boolean,
     *          telegram: Boolean,
     *          periodicity?: Number
     *      },
     *      schedule: {
     *          periodicity: Number,
     *          selected: Number[],
     *          time: {
     *              hour: ?Number,
     *              minute: ?Number
     *          }
     *      },
     *      competitors: {
     *          name: string,
     *          trackingItem: string,
     *          trackSubDomains: boolean,
     *          trackMainPageOnly: boolean,
     *          visible: boolean,
     *      }[]|[],
     * }}
     */
    static dataSettingsFromRequest(dataResponse) {
        const schedulePeriodicity = dataResponse.schedulerSetting.type;
        const isSelectedPeriodicity = [
            Periodicity.SCHEDULE_PERIODICITY_BY_WEEK,
            Periodicity.SCHEDULE_PERIODICITY_BY_MONTH,
        ].includes(schedulePeriodicity);

        let selected = [];
        if (isSelectedPeriodicity) {
            switch (schedulePeriodicity) {
                case Periodicity.SCHEDULE_PERIODICITY_BY_WEEK:
                    selected = dataResponse.schedulerSetting.daysOfWeek.split(',')
                    break;
                case Periodicity.SCHEDULE_PERIODICITY_BY_MONTH:
                    selected = dataResponse.schedulerSetting.daysOfMonth.split(',')
                    break;
            }
        }

        return {
            domain: dataResponse.trackingItem,
            subdomains: dataResponse.trackSubDomains,
            name: dataResponse.name,
            searchSettings: this.searchFromRequest(dataResponse.searchSettings),
            notifications: {
                isNotifyMuted: !dataResponse.alertSetting.active,
                email: dataResponse.alertSetting.notifyEmail,
                telegram: dataResponse.alertSetting.notifyTelegram,
                // временно убрали
                // periodicity: dataResponse.alertSetting.interval,
            },
            schedule: {
                periodicity: schedulePeriodicity,
                selected: selected.map(stringNumber => Number(stringNumber)),
                time: (
                    isSelectedPeriodicity
                        ? {
                            hour: (isSelectedPeriodicity ? dataResponse.schedulerSetting.checkHour : null),
                            minute: (isSelectedPeriodicity ? dataResponse.schedulerSetting.checkMinute : null),
                        }
                        : null
                ),
            },
            competitors: dataResponse.competitors,
        };
    }

    /**
     * Формируем данные из формата модели компонента в формат для API
     * @param dataModel
     * @returns {{
     *      trackingItem: String,
     *      trackSubDomains: Boolean,
     *      name: String,
     *      searchSettings: {
     *          regionId: Number,
     *          language: Number,
     *          engine: Number
     *      }[],
     *      schedulerSetting: {
     *          type: Number,
     *          daysOfWeek: ?String,
     *          daysOfMonth: ?String,
     *          checkHour: ?Number,
     *          checkMinute: ?Number
     *      },
     *      alertSetting: {
     *          active: Boolean,
     *          interval?: Number,
     *          notifyEmail: Boolean,
     *          notifyTelegram: Boolean,
     *      },
     *      competitors: {
     *          name: string,
     *          trackingItem: string,
     *          trackMainPageOnly: boolean,
     *          visible: boolean,
     *      }[],
     * }}
     */
    static dataSettingsForRequest(dataModel) {
        const periodicity = dataModel.schedule.periodicity;
        const isSelectedPeriodicity = [
            Periodicity.SCHEDULE_PERIODICITY_BY_WEEK,
            Periodicity.SCHEDULE_PERIODICITY_BY_MONTH,
        ].includes(periodicity);

        return {
            trackingItem: dataModel.domain,
            trackSubDomains: dataModel.subdomains,
            name: dataModel.name,
            searchSettings: this.searchForRequest(dataModel.searchSettings),
            schedulerSetting: {
                type: periodicity,
                daysOfWeek: (
                    periodicity === Periodicity.SCHEDULE_PERIODICITY_BY_WEEK ? dataModel.schedule.selected.join() : null
                ),
                daysOfMonth: (
                    periodicity === Periodicity.SCHEDULE_PERIODICITY_BY_MONTH ? dataModel.schedule.selected.join() : null
                ),
                checkHour: (isSelectedPeriodicity ? dataModel.schedule.time.hour : null),
                checkMinute: (isSelectedPeriodicity ? dataModel.schedule.time.minute : null),
            },
            alertSetting: {
                active: !dataModel.notifications.isNotifyMuted,
                // временно убрали
                // interval: dataModel.notifications.periodicity,
                notifyEmail: dataModel.notifications.email,
                notifyTelegram: dataModel.notifications.telegram,
            },
            // передаём только элементы, у которых заполнен trackingItem
            competitors: dataModel.competitors.filter(item => item.trackingItem?.trim()),
        };
    }

    /**
     * Формируем данные для обновления проекта из формата модели компонента в формат для API
     * @param dataModel
     * @returns {{
     *      aids?: Number[],
     *      searchSettings: {
     *          regionId: Number,
     *          language: Number,
     *          engine: Number
     *      }[]
     * }}
     */
    static dataForRequestUpdate(dataModel) {
        return {
            aids: dataModel.selectedArts,
            searchSettings: this.searchForRequest(dataModel.regions),
        }
    }

    /**
     * Формируем данные для получения всех дат, по которым есть данные с учетом фильтра папок и регионов
     * из формата модели компонента в формат для API
     * @param dataModel
     * @returns {{
     *      aids?: Number[],
     *      searchSettings: {
     *          regionId: Number,
     *          language: Number,
     *          engine: Number
     *      }[]
     * }}
     */
    static dataForRequestDates(dataModel) {
        return this.dataForRequestUpdate(dataModel);
    }

    /**
     * Формируем данные для запроса к API из модели компонента
     * @param dataModel
     * @returns {{
     *      aids?: Number[],
     *      dateFrom: String,
     *      dateTo: String,
     *      search: String,
     *      filter: String,
     *      per_page: Number,
     *      page: Number,
     *      sort: String,
     *      searchSettings: {
     *          regionId: Number,
     *          engine: Number,
     *      }[]
     * }}
     */
    static dataForRequest(dataModel) {
        // для того, чтобы избавится от ссылки на объект, создаем новый
        const payload = Object.assign({}, dataModel);

        payload.searchSettings = this.searchForRequest(payload.regions);
        // добавляем папки только если не выбрана "Все папки"
        if (payload.selectedArts.length > 0) {
            payload.aids = payload.selectedArts;
        }

        // отправляем только trackingItem доменов
        payload.trackingItems = ArrayHelper.getAttrValuesOfObjectsByName(payload.domains, 'trackingItem');

        // удаляем ненужные данные
        delete payload.regions;
        delete payload.selectedArts;
        delete payload.domains;

        let dateFrom = moment(payload.dateFrom, 'DD.MM.YYYY');
        payload.dateFrom = dateFrom.isValid() ? dateFrom.format('YYYY-MM-DD') : '';

        let dateTo = moment(payload.dateTo, 'DD.MM.YYYY');
        payload.dateTo = dateTo.isValid() ? dateTo.format('YYYY-MM-DD') : '';

        return payload;
    }
}
